import {Component, Input, ViewChild} from '@angular/core';
import {TimecardStatus} from '../../../model';
import {ModalComponent} from '../../shared/modal/modal.component';
import {ClientApiService} from '../client-api.service';
import {NavigationService} from '../../shared/navigation.service';

@Component({
  selector: 'timecard-sign',
  templateUrl: './timecard-sign.component.html',
  styleUrls: ['./timecard-sign.component.scss'],
  host: {
    '[class.signed]': 'timecard.statusId != Status.Submitted && timecard.statusId != Status.Disputed'
  }
})
export class TimecardSignComponent {

  @Input() timecard: TimecardDetails;

  Status = TimecardStatus;

  @ViewChild('termsModal') termsModal: ModalComponent;

  constructor(private Navigation: NavigationService,
              private Api: ClientApiService) {
  }

  signTimecardComplete() {
    this.Api.getTimecardStatusDetails(this.timecard.timecardId)
      .subscribe(data => {
        // FIXME bad; should reload/replace original timecard
        this.timecard.statusId = data.statusId;
        this.timecard.statusName = data.statusName;
        this.timecard.signed = data.signed;
        this.timecard.signedBy = data.signedBy;
        this.timecard.approved = data.approved;
        this.timecard.approvedBy = data.approvedBy;
      }, err => {
        this.handleError(err);
      });
  }

  handleError(err) {
    console.error('Failed to load timecard', err);

    if (err.status === 401) {
      this.Navigation.handleLogin();
    } else {
      this.Navigation.handleError(err);
    }
  }

  getSignedDate(): Date {
    return this.timecard.statusId === TimecardStatus.Signed ? this.timecard.signed : this.timecard.approved;
  }

  getSignedBy(): Person {
    return this.timecard.statusId === TimecardStatus.Signed ? this.timecard.signedBy : this.timecard.approvedBy;
  }
}
